module.exports = __webpack_public_path__ + "e36815313b6e089e435d5f85bdc4c14e.svg";